import { render, staticRenderFns } from "./Riding.vue?vue&type=template&id=b7a34a38&scoped=true&"
import script from "./Riding.vue?vue&type=script&lang=js&"
export * from "./Riding.vue?vue&type=script&lang=js&"
import style0 from "./Riding.vue?vue&type=style&index=0&id=b7a34a38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a34a38",
  null
  
)

export default component.exports